export default __webpack_public_path__ + "media/pro/forward-4080e875.svg";